<template>
  <div class="content">
    <div class="content" style="background: white;">
      <p class="chinese-name">最新资讯</p>
      <p class="english-name">INFORMATION </p>
    </div>
    <div class="box">
      <div class="swiper-content">
        <a-carousel
          :dots="true"
          style="width: 570px"
          autoplay
        >
          <div
            v-for="item in list"
            class="swiper-box"
            :key="item"
          >
            <div :key="item.contentCode" @click="goDetail(item.contentCode)">
              <div class="swiper-title">{{ item.contentTitle }}</div>
              <div class="swiper-desc">{{ item.contentSubtitle }}...</div>
<!--              <div class="swiper-time">{{ item.createTime }} 来源：{{ item.releaseName }}</div>-->
            </div>
          </div>
        </a-carousel>
        <a-carousel
          :dots="false"
          style="width: 570px"
          autoplay
          ref="swiper"
        >
          <div class="swiper-box" v-for="item in imgs" :key="item.picCode">
            <!-- <img :src="item.fileHttpUrl"> -->
            <ffcs-img class="img" :fileCode="item.contentPicFileDtoList[0].fileCode" />
            <p class="pname">{{ item.picName }}</p>
          </div>
        </a-carousel>
        <div class="arrow">
          <p @click="choose(true)"><img src="../../../assets/images/icon_carousel_left_white.png"></p>
          <p @click="choose(false)"><img src="../../../assets/images/icon_carousel_right_white.png"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getConsultThePicture,
  getConsultTheInfo,
  getConsultTheInfoDetail,
  getPic,
  getPicByPicCode,
} from '@/api/service.js'
import {
  getFileDetails
} from '@/api/file.js'
export default {
  name: 'information-consulting',
  data () {
    return {
      imgs: [],
      list: [],
      remark:[]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    goDetail (contentCode) {
      this.pushRouter(`/guide?contentCode=${contentCode}&linkname=出国服务/最新资讯/详情`)
    },
    choose (isprev) {
      if (isprev) {
        this.$refs && this.$refs.swiper.prev()
      } else {
        this.$refs && this.$refs.swiper.next()
      }
    },
    async getList () {
      const res = await getPic('RES326F74654C116E3')
      console.log('res--最新资讯', res);
      const imgs= res.data.records.sort((a, b) => a.picSort - b.picSort) || []
      imgs.forEach( async img => {
        const ret = await getPicByPicCode(img.picCode)
        this.imgs.push(ret.data)
      });
      // this.imgs=temp
      // console.log('ret--最新资讯tu', temp);
      

      // getConsultThePicture().then(res => {
      //   console.log('res', res);
      //   this.imgs=res.data.contentPicFileDtoList
      //   return
      //   this.remark = res.data.contentPicFileDtoList
      //   const appCode = this._.get(res, 'data.appCode', '')
      //   const tenantCode = this._.get(res, 'data.tenantCode', '')
      //   const fileCode = this._.get(res, 'data.contentPicFileDtoList', []).map(item => item.fileCode)
      //   getFileDetails(appCode, tenantCode, fileCode).then(res => {
          
      //     this.imgs = Object.values(this._.get(res, 'data'))
      //     console.log('this.imgs====>', this.imgs);
      //   })
      // })
      getConsultTheInfo().then(res => {
        this.list = this._.get(res, 'data.records', [])
        for(let i = 0; i < this.list.length; i++) {
          this.list[i].createTime = String(this.list[i].createTime).split(' ')[0].split('-')[0] + '年' + String(this.list[i].createTime).split(' ')[0].split('-')[1] + '月'
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  background: #DCDCDC;
  position: relative;
  margin-top: 20px;
}
.box {
  width: 1140px;
  height: 384px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FAF5F5;
  position: relative;
}
.swiper-content {
  height: 480px;
  width: 1140px;
  position: relative;
  display: flex;
  .swiper-box {
    width: 570px;
    height: 384px;
    background: #DCDCDC;
    text-align: center;
    position: relative;
    .img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    top: 158px;
    width: 42px;
    height: 70px;
    background: #000000;
    opacity: 0.8;
    line-height: 70px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: 50%;
  }
  p:last-of-type {
    right: 0px;
  }
}
.swiper-title {
  width: 341px;
  height: 77px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 48px;
  text-align: left;
  margin-top: 33px;
  cursor: pointer;
}
.swiper-desc {
  width: 438px;
  height: 100px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999BA3;
  text-align: left;
  margin-top: 33px;
  cursor: pointer;
  text-indent: 2em;
}
.swiper-time {
  width: 100%;
  height: 15px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #959DA9;
  position: absolute;
  bottom: 80px;
  left: 0;
  text-align: left;
  cursor: pointer;
}
/deep/.slick-track {
  width: 570px;
}
/deep/ .ant-carousel .slick-dots li button {
  width: 16px;
  height: 16px;
  background: #D7CDBE;
}
/deep/ .ant-carousel .slick-dots li.slick-active button {
  background: #CDAD7F;
}
/deep/ .ant-carousel .slick-dots-bottom {
  bottom: 30px;
  left: -43px;
}

.pname {
  position: absolute;
  z-index: 999;
  font-size: 16px;
  color: white;
  bottom: 1px;
  text-align: left;
  width: 100%;
  padding-left: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/serviceAbroad/siderContent-02.vue